import { render, staticRenderFns } from "./CreateCom.vue?vue&type=template&id=6801a9a0&scoped=true"
import script from "./CreateCom.vue?vue&type=script&lang=js"
export * from "./CreateCom.vue?vue&type=script&lang=js"
import style0 from "./CreateCom.vue?vue&type=style&index=0&id=6801a9a0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6801a9a0",
  null
  
)

export default component.exports